import { Link } from 'react-router';
import { ThemeToggle } from '@mieweb/ui';
import { BrandLockup } from '../BrandMark';

const NAV_LINKS = [
  { label: 'Developers', to: '/developers' },
  { label: 'AI', to: '/ai' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Compare', to: '/vs' },
  { label: 'Use cases', to: '/use-cases' },
  { label: 'Guides', to: '/guides' },
  { label: 'Docs', to: '/docs' },
];

/**
 * Shared marketing site header used across content, pricing, about, and
 * collection index pages. Keeps navigation and CTAs consistent for both
 * users and crawlers (internal-linking signal).
 */
export function MarketingHeader() {
  return (
    <header className="sticky top-0 z-50 bg-white/80 dark:bg-neutral-950/80 backdrop-blur-xl border-b border-slate-200/70 dark:border-neutral-800/70">
      <nav className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Primary">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2" aria-label="Pollenate home">
            <BrandLockup
              iconClassName="h-7 w-7"
              textClassName="text-xl font-bold text-slate-900 dark:text-white"
            />
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-slate-500 dark:text-neutral-400 hover:text-slate-900 dark:hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <ThemeToggle mode="two-way" size="sm" variant="ghost" />
            <Link
              to="/login"
              className="hidden sm:inline text-sm font-medium text-slate-500 dark:text-neutral-400 hover:text-slate-900 dark:hover:text-white transition-colors"
            >
              Sign in
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center rounded-lg bg-gradient-to-r from-amber-500 to-orange-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:from-amber-600 hover:to-orange-600 transition-colors"
            >
              Get started
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}
